<template>
    <v-btn-toggle
        v-model = "modes"
        color   = "primary"
        @change = onModes
        multiple
        dense
        rounded
        group
    >
        <v-btn
            value = "all-orders"
            class = "disposition-button"
        >
            <v-icon size="22" color="primary">mdi-folder</v-icon>
            <span class="pl-1">{{ $t("disposition.modes.allOrders") }}</span>
        </v-btn>

        <v-btn
            value = "map"
            class = "disposition-button"
        >
            <v-icon size="22" color="primary">mdi-map</v-icon>
            <span>{{ $t("disposition.modes.map") }} </span>
        </v-btn>

        <v-btn
            v-if  = "isDisponent && !isAllOrdersOn"
            value = "assign"
            class = "disposition-button"
        >
            <v-icon size="22" color="primary">mdi-plus</v-icon>
            <span>{{ $t("disposition.modes.assign") }} </span>
        </v-btn>

        <v-btn
            v-if  = "isDispatcher || isDispatcher || isRestrictedDispatcher"
            value = "dispatch"
            class = "disposition-button"
        >
            <v-icon size="22" color="primary">mdi-account</v-icon>
            <span>{{ $t("disposition.modes.dispatch") }}</span>
        </v-btn>

    </v-btn-toggle>
</template>

<script>

import DispositionSecurityMixin from "@/modules/dis/mixins/DispositionSecurityMixin";

export default {
    name: "PDispositionButtons",

    props: {
        /**
         * The currently selected user
         */
        user: {

        }
    },

    mixins: [
        DispositionSecurityMixin
    ],

    data: () => ({
        modes: [],
        allOrders: false,
        dispatch: false,
        map: false,
        assign: false
    }),

    computed: {
        isAllOrdersOn () {
            return this.modes.findIndex(mode => mode === "all-orders") >= 0;
        },

        isAssignOn () {
            return this.modes.findIndex(mode => mode === "assign") >= 0;
        },

        isDispatchOn () {
            return this.modes.findIndex(mode => mode === "dispatch") >= 0;
        },

        isMapOn () {
            return this.modes.findIndex(mode => mode === "map") >= 0;
        },
    },

    methods: {
        reset () {
            this.modes = [];
        },

        closeMap () {
            const index = this.modes.findIndex(m => m === "map");
            if (index >= 0) {
                this.modes.splice(index, 1);
            }

            this.map = false;
            this.$emit("map", this.map);
        },

        onModes () {
            if (this.isAllOrdersOn !== this.allOrders) {
                this.allOrders = this.isAllOrdersOn;
                this.$emit("all-orders", this.allOrders);
            }

            if (this.isMapOn !== this.map) {
                this.map = this.isMapOn;
                this.$emit("map", this.map);
            }

            if (this.isAssignOn !== this.assign) {
                this.assign = this.isAssignOn;
                this.$emit("assign", this.assign);

                this.$nextTick().then(() => {
                    if (this.assign) {
                        const index = this.modes.findIndex(m => m === "dispatch");
                        if (index >= 0) {
                            this.modes.splice(index, 1);
                        }

                        this.dispatch = false;
                        this.$emit("dispatch", this.dispatch);
                    }
                });
            }

            if (this.isDispatchOn !== this.dispatch) {
                this.dispatch = this.isDispatchOn;
                this.$emit("dispatch", this.dispatch);

                this.$nextTick().then(() => {
                    if (this.dispatch) {
                        const index = this.modes.findIndex(m => m === "assign");
                        if (index >= 0) {
                            this.modes.splice(index, 1);
                        }
                        this.assign = false;
                        this.$emit("assign", this.assign);
                    }
                });
            }
        },
    }
}
</script>

<style scoped>

.disposition-button {
    height: 36px!important;
    text-transform: none;
    letter-spacing: unset;
    font-size: 15px!important;
    font-weight: normal;
}

.disposition-button span {
    margin-top: 2px
}

/*noinspection CssUnusedSymbol*/
::v-deep .v-btn-toggle>.v-btn.v-btn {
    opacity: 1.0;
}

/*noinspection CssUnusedSymbol*/
::v-deep .theme--light.v-btn.v-btn--has-bg {
    background-color: white;
}

/*noinspection CssUnusedSymbol*/
::v-deep .v-btn:not(.v-btn--text):not(.v-btn--outlined):hover:before {
    opacity: 0.1;
}

</style>